import { LabelTitleIntroduction } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { slugify } from '@shared/Frontend/utils/slugify'
import React from 'react'

export const BlockHeader = (
  props: LabelTitleIntroduction & {
    headerClassName?: string
    titleClassName?: string
    labelClassName?: string
    introClassName?: string
  }
) => {
  const { label, title, introduction, headerClassName, titleClassName, labelClassName, introClassName } = props
  if (!label && !title && !introduction) return <></>
  return (
    <header className={cn('block__header', headerClassName)}>
      {(title || label) && (
        <div className="block__header-inner ls-reversed-column">
          {title && (
            <h2 id={slugify(title)} className={cn('block__title title--lg', titleClassName)}>
              {title}
            </h2>
          )}
          {label && <p className={cn('block__label text--sm', labelClassName)}>{label}</p>}
        </div>
      )}
      {introduction && <p className={cn('block__intro text--xl', introClassName)}>{introduction}</p>}
    </header>
  )
}
